import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;

// Planning V2 activé pour l'entreprise ? null = chargement. Hors V2, les écrans de production restent strictement inchangés.
export function usePlanningV2() {
  const [v2, setV2] = useState(null);
  useEffect(() => {
    cached = cached || api.get("/organization").then((r) => !!r.data.planning_v2_enabled).catch(() => { cached = null; return false; });
    cached.then(setV2);
  }, []);
  return v2;
}
